import * as t from "io-ts"

// DNO Config response — key-value pairs from dno-config table
const DnoConfigItem = t.type({
    name: t.string,
    value: t.union([t.string, t.number, t.boolean, t.null]),
})

export const DnoConfigResponse = t.type({
    config: t.array(DnoConfigItem),
})

export type IDnoConfigResponse = t.TypeOf<typeof DnoConfigResponse>
export type IDnoConfigItem = t.TypeOf<typeof DnoConfigItem>

// Licence Area Thresholds response
const ThresholdItem = t.type({
    name: t.string,
    value: t.union([t.string, t.number, t.boolean, t.null]),
})

export const LicenceAreaThresholdsResponse = t.type({
    thresholds: t.record(t.string, t.array(ThresholdItem)),
})

export type ILicenceAreaThresholdsResponse = t.TypeOf<
    typeof LicenceAreaThresholdsResponse
>
export type IThresholdItem = t.TypeOf<typeof ThresholdItem>

// Change request types
const ChangeDetail = t.intersection([
    t.type({
        field: t.string,
        oldValue: t.union([t.string, t.number, t.boolean, t.null]),
        newValue: t.union([t.string, t.number, t.boolean, t.null]),
    }),
    t.partial({
        key: t.union([t.string, t.null]),
    }),
])

const ChangeRequest = t.intersection([
    t.type({
        changeRequestId: t.string,
        status: t.string,
        title: t.string,
        comment: t.string,
        changes: t.array(ChangeDetail),
        raisedBy: t.string,
        raisedByName: t.string,
        raisedByEmail: t.string,
        raisedAt: t.string,
        version: t.number,
    }),
    t.partial({
        reviewedBy: t.union([t.string, t.null]),
        reviewedByName: t.union([t.string, t.null]),
        reviewedByEmail: t.union([t.string, t.null]),
        reviewedAt: t.union([t.string, t.null]),
        approvalComment: t.union([t.string, t.null]),
    }),
])

export const ChangeRequestsResponse = t.type({
    changeRequests: t.array(ChangeRequest),
})

export type IChangeRequestsResponse = t.TypeOf<typeof ChangeRequestsResponse>
export type IChangeRequest = t.TypeOf<typeof ChangeRequest>
export type IChangeDetail = t.TypeOf<typeof ChangeDetail>

// Lock status
export const LockStatusResponse = t.type({
    isLocked: t.boolean,
    lockedBy: t.union([t.string, t.null]),
    lockedByName: t.union([t.string, t.null]),
    remainingSeconds: t.number,
})

export type ILockStatusResponse = t.TypeOf<typeof LockStatusResponse>
